import React from 'react';
import { DateTime } from 'luxon';
import DayPicker from 'react-day-picker';
import { instanceOf, func, string, bool, object, oneOfType } from 'prop-types';
import Dropdown from '../dropdown';
import setClass from '../../common/set-class';
import NavBar from '../date-range-select/nav-bar';
import Weekday from '../date-range-select/weekday';
import Icon from '../icon';
const DatePicker = ({ value, onChange, format, placeholder, isDisabled, dayPickerProps, isOpen, className, style, error, wrapperRef, onClose, }) => (React.createElement("div", { className: setClass('b-date-range b-date-picker', className), style: style, ref: wrapperRef },
    React.createElement(Dropdown, { isDisabled: isDisabled, isOpen: isOpen, name: "date-range-picker", render: (close) => (React.createElement(DayPicker, { selectedDays: [value], onDayClick: (day) => {
                close();
                onChange(day);
            }, navbarElement: NavBar, weekdayElement: Weekday, ...dayPickerProps })), onClose: onClose },
        React.createElement("div", { className: setClass('b-txt-input__elm', 'b-date-range__trigger', error && 'b-txt-input__elm--error'), 
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: any[]; className: string; disabl... Remove this comment to see the full error message
            disabled: isDisabled },
            value && DateTime.fromJSDate(value).toFormat(format),
            !value && React.createElement("span", { className: "b-txt-light" },
                " ",
                placeholder,
                " "),
            React.createElement(Icon, { name: "calendar", size: 18 }))),
    error && (React.createElement("div", { className: "b-date-picker__err-msg" },
        React.createElement(Icon, { name: "triangle-exclamation", className: "b-txt-input__err-icon" }),
        React.createElement("p", { className: "b-txt b-txt--error" }, error)))));
DatePicker.propTypes = {
    value: instanceOf(Date).isRequired,
    onChange: func.isRequired,
    format: string,
    placeholder: string,
    isDisabled: bool,
    isOpen: bool,
    dayPickerProps: object,
    className: string,
    style: object,
    error: oneOfType([bool, string]),
    wrapperRef: object,
    onClose: func,
};
DatePicker.defaultProps = {
    format: 'MMMM dd, yyyy',
    placeholder: 'MM/DD/YY',
    isDisabled: false,
    isOpen: null,
    dayPickerProps: {},
    className: null,
    style: {},
    error: false,
    wrapperRef: null,
    onClose: null,
};
export default DatePicker;
